import {useTranslations} from 'use-intl'
import Card from '~/components/common/Card'

type BasketErrorProps = {
    error?: Error
}

export const BasketError = ({error}: BasketErrorProps) => {
    const t = useTranslations('basket.error')

    return (
        <div className="p-4 space-y-2">
            <h2 className="text-lg">{t('title')}</h2>
            <p className="text-sm">{t('description')}</p>
            {!!error && <p>{error.message}</p>}
        </div>
    )
}

export const BasketErrorCard = ({error}: BasketErrorProps) => {
    return (
        <Card variant="desructive">
            <BasketError error={error} />
        </Card>
    )
}
